import { Controller } from "@hotwired/stimulus"

export default class ImportUploadController extends Controller {
  declare dropzoneTarget: HTMLDivElement
  declare fileInputTarget: HTMLInputElement

  static targets = ["dropzone", "fileInput"]

  connect(): void {
    this.setupDragAndDrop()
  }

  private setupDragAndDrop(): void {
    const dropzone = this.dropzoneTarget

    dropzone.addEventListener("dragover", (e: DragEvent) => {
      e.preventDefault()
      dropzone.classList.add("border-primary", "bg-light-primary")
    })

    dropzone.addEventListener("dragleave", () => {
      dropzone.classList.remove("border-primary", "bg-light-primary")
    })

    dropzone.addEventListener("drop", (e: DragEvent) => {
      e.preventDefault()
      dropzone.classList.remove("border-primary", "bg-light-primary")

      if (e.dataTransfer?.files.length) {
        const file = e.dataTransfer.files[0]
        this.handleFile(file)
      }
    })
  }

  private handleFile(file: File): void {
    const validTypes = [
      "text/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ]

    const validExtensions = [".csv", ".xls", ".xlsx"]
    const extension = file.name.toLowerCase().slice(file.name.lastIndexOf("."))

    if (!validTypes.includes(file.type) && !validExtensions.includes(extension)) {
      alert("Please select a valid CSV or Excel file.")
      return
    }

    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    this.fileInputTarget.files = dataTransfer.files
  }
}
